import * as React from "react";
import { useQuery } from "@tanstack/react-query";

import { PostServices } from "@/services";
import { ReadyToPostCard } from "./components/ReadyToPostCard";
import { Skeleton } from "@/components/ui";

interface OwnProps {
  playerId: number;
}

type Props = OwnProps;

const ReadyToPostFC: React.FC<Props> = ({ playerId }) => {
  const {
    data: postsData,
    isLoading: loading,
    refetch: getPost,
  } = useQuery({
    queryKey: ["readyToPostPosts", playerId],
    queryFn: () => PostServices.readyToPost(playerId),
    enabled: !!playerId,
  });

  const posts = postsData || [];

  return (
    <div className="readyToPostContent w-full">
      <div className="w-full flex flex-col gap-4">
        {loading ? (
          <div className="readyToPost flex flex-col gap-3 w-full">
            <div className="flex flex-row items-center gap-2">
              <Skeleton className="h-8 w-48" />
            </div>
            <div className="flex flex-row overflow-x-auto gap-4 w-full pb-3 scrollbar-thin scrollbar-thumb-slate-200 select-none">
              {Array.from({ length: 4 }).map((_, idx) => (
                <div
                  key={`skeleton-${idx}`}
                  style={{ width: "220px", height: "220px" }}
                  className="bg-white rounded border border-slate-100 overflow-hidden animate-pulse shrink-0 p-0"
                >
                  <Skeleton className="size-full rounded" />
                </div>
              ))}
            </div>
          </div>
        ) : posts && posts.length > 0 ? (
          <div className="readyToPost flex flex-col gap-3 w-full">
            <div className="flex flex-row items-center gap-2">
              <div className="text-2xl font-bold text-slate-700 leading-snug">Suggested for You</div>
            </div>
            {/* Horizontally scrolling list container with tight spacing */}
            <div className="flex flex-row overflow-x-auto gap-4 w-full pb-3 scrollbar-thin scrollbar-thumb-slate-200">
              {posts.map((post, index) => (
                <ReadyToPostCard key={index} post={post} refreshHandler={getPost} />
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export const ReadyToPost = ReadyToPostFC;
